import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditTestimonial from "../../components/testimonials/FormAddEditTestimonial";
import { useGetTestimonial } from "../../hooks/testimonials/useGetTestimonial";
import LoadingPage from "../../components/global/LoadingPage";

const EditTestimonial = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, item } = useGetTestimonial(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/testimonials");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTestimonial
                isEdit={true}
                currentData={item}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditTestimonial;
